// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2pk5U","fullWidth":"button_fullWidth__1lIBo","children":"button_children__B4Ndf","animation":"button_animation__1nf_l"};